import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.COMPANY_EDIT_SUCCESS, data: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.COMPANY_EDIT_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const companyEdit = (companyId, data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.COMPANY_EDIT_REQUEST });

    axios.patch(`/companies/${companyId}`, data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
